// extracted by mini-css-extract-plugin
export var active = "_ao-7";
export var container = "_ao-0";
export var evenWidth = "_ao-4";
export var large = "_ao-5";
export var outlet = "_ao-8";
export var slide = "_ao-2";
export var small = "_ao-6";
export var tab = "_ao-3";
export var tabs = "_ao-1";